<template>
  <div class="ui-table scroll">
    <table id="myTable" class="table sys-font" :class="{'tb-border': showBorder == true, 'no-zebra': noZebra == true}" 
            border="0" cellspacing="0" cellpadding="4" bgcolor="#fff"  align="left" 
            :style="{'font-size': fontSize}"
            :width="tableWidth ? tableWidth : '100%'">
      <tr>
        <th v-if="showCheck == true" align="center" width="70" :class="{'td-border': showBorder == true}" >
          <input v-model="checkedAll" ref="check-all" @change="selectChange" type="checkbox" class="checkbox"/>
        </th>
        <th v-if="showNo == true" align="center" width="30" :class="{'td-border': showBorder == true}" >序号</th>
        <th v-for="item,i in fields" align="center" :width="item.width" :style="{cursor:item.orderName?'pointer':''}" :class="{'td-border': showBorder == true}" :key="'i'+i" @click="onClickHead(item)">
          <span>{{item.title}}
            <span class="menu-down menu-black" v-if="item.sort == 'desc'"></span>
            <span class="menu-up menu-up-black" v-if="item.sort == 'asc'"></span>
          </span>
          <!-- <span class="resizable" style="position: absolute; right: 0; top: 0; width: 10px; height: 100%; background-color: transparent;"></span> -->
        </th>
        <th v-for="item,j in opFields" align="center" :width="item.width" :class="{'fixed': item.fixed == true,'td-border': showBorder == true }" :key="'j'+j">
          {{item.title}}
          <!-- <span class="resizable" style="position: absolute; right: 0; top: 0; width: 5px; height: 100%; background-color: transparent;"></span> -->
        </th>
      </tr>
      <tr v-for="record,index in data" :key="'index'+index" :class="record.breathe?'breathe':''">
        <td v-if="showCheck == true" align="center" width="70" :class="{'td-border': showBorder == true}" >
          <input :value="record.id" v-model="checks" type="checkbox" class="checkbox" ref="check-one" @change="selectOneChange"/>
        </td>
        <td v-if="showNo == true" align="center" width="70" :class="{'td-border': showBorder == true}">{{index+1}}</td>
        <td v-for="field,k in showColField(record,fields)" class="pointer full-width text text-more" 
             :rowspan="getSpan(record, field)"
             :style="getStyle(index, field)"
             :class="{'td-border': showBorder == true}"
             @click="cellClick(record.id,field.fieldName,record )" :data-field="field.fieldName" :data-id="record.id"  :align="field.align ? field.align : 'center'" 
             :key="'k'+k">
            
            <span v-if="showText(record, field)"
                :ref="'text_' + field.fieldName+'_' + record.id" 
                :data-field="field.fieldName" 
                :data-id="record.id"
                :title="getValue(record, field)"
                :class="field.title.indexOf('姓名')>-1 ?'ldw-text-text':''">{{getValue(record, field)}}</span>

            <span v-if="showInputEdit(record, field)" class="margin-left-l pointer">
                <img class="logo-20" src="@/assets/images/edit.png" @click="fileNameEdit" :data-field="field.fieldName" :data-id="record.id"/>
            </span>

            <span v-if="showCheckBox(field)" class="flex flex-center-sp">
                <img v-if="getValue(record, field) == '1'" class="logo-22" src="@/assets/images/checked.png" />
                <img v-if="getValue(record, field) != '1'"  class="logo-22" src="@/assets/images/nocheck.png" />
            </span>

            <span v-if="showSelect(field)" class="flex flex-center-sp">
                <input class="checkbox" type="checkbox" v-model="record.finishFlag" />
            </span>
            
            <span v-if="showImg(field)" class="flex flex-center-sp" style="width: 48px; height: 48px">
              <img class="picture" :src="getValue(record, field)"/>
            </span>

            <span v-if="showTag(field) && getArray(record, field).length>0" class="flex flex-center-sp">
              <span v-for="tag,l in getArray(record, field)" class="tag flex flex-center-sp" :key="'l'+l">{{tag}}</span>
            </span>

            <span v-if="showInput(record, field)">
              <input type="text" v-model="fileName" @blur="fileNameBlur" :ref="'input_' + field.fieldName+'_' + record.id">    
            </span>

            <span v-if="showOther(field)" class="flex flex-center-sp" :style="getOtherStyle(record, field)">
              <span :title="getValue(record, field)">{{getValue(record, field)}}</span>
            </span>

            <slot v-if="showTemplate(field)" :name="field.fieldName" :record="record"></slot>

        </td>
        <td v-for="field,m in opFields" :style="getStyle(index, field)" :class="{'td-border': showBorder == true}" :key="'m'+m">
            <slot :name="field.name" :fieldName="field.fieldName" :recordId="record.id" :record='record'></slot>
        </td>       
      </tr>
    </table>
  </div>

</template>

<script>
import * as dateUtils from '@/utils/dateUtils.js'
export default {
  name: 'MyTable',  
  props: {
      opFields: {},
      fields: {},
      data:{},
      noZebra:{},
      showNo:{},
      showCheck:{},
      showBorder:{},
      tableWidth: {},
      fontSize:{}
  },
  data() {
      return {
          checkedAll: false,
          checks:[],
          editMode: false,
          editId: 0,
          editName:'',
          fileName:"",
          groupData:{}
      }
  },
  watch:{
      data: {
          handler(newValue) {
              this.groupData = {};
              this.fields.forEach(item=>{
                if (item.spanFlag == true) {
                  this.setData(newValue, item.fieldName);
                }
              })
          },
          immediate: true,
          deep: true   //深度监听
      }
  },

  computed: {
   
  },
  mounted(){
    var resizing = false;  
    var lastX = 0;  
    var lastW = 0;  

  },
  methods: {
    onClickHead(item) {
      this.fields.filter(i=>i.fieldName!=item.fieldName).forEach(f=>{
        delete f.sort
      })
      if(item.orderName){
        if(!item.sort){
          let record = {}
          record.orderByField = item.orderName
          record.orderBySort = "desc"
          this.$emit("order",record)
          item.sort = "desc"
        }else{
          if(item.sort == "desc"){
            let record = {}
            record.orderByField = item.orderName
            record.orderBySort = "asc"
            this.$emit("order",record)
            item.sort = "asc"
          }else if(item.sort == "asc"){
            let record = {}
            record.orderByField = null
            record.orderBySort = null
            this.$emit("order",record)
            item.sort = null
          }
        }
      }
    },
    selectChange() {
      if (!this.checkedAll) {
        this.checks = [];
      } else {
        this.checks = [];
        this.data.forEach(item => {
          this.checks.push(item.id)
        });
      }
      console.log(this.checkedAll);
      this.$emit("checkboxChange", this.checks);
    },
    setData(data, fieldName) {
      this.groupData[fieldName] = data.groupBy(fieldName) ;
    },

    selectOneChange() {
      console.log(this.checks);
      this.$emit("checkboxChange", this.checks);
    },
    getValue(record, field) {
      let result = record[field.fieldName];
      if (field.dateType != null) {
        if  (field.dateType=='date') {
          result = dateUtils.getJsDate(result);
        }
        if  (field.dateType=='dateTime') {
          result = dateUtils.getJsDateTime(result);
        }
      }
      return result;
    },
    getArray(record, field) {
      let result = record[field.fieldName];
      let array = [];
      if (result !=null && result != "") {
        array = result.split(",");
      }
      return array;
    },
    getSpan(record, field) {
      let result = -1
      if (field.spanFlag == true) {
        if (record.id == this.groupData[field.fieldName][record[field.fieldName]][0].id) {
          result =  this.groupData[field.fieldName][record[field.fieldName]].length;
        }
      }
      return result;
    },
    showColField(record,fields){
      return fields.filter(field=> this.showCol(record,field))
    },
    showCol(record, field) {
      let result = true;
      if (field.spanFlag && field.spanFlag == true) {
        if (record.id != this.groupData[field.fieldName][record[field.fieldName]][0].id) {
          result = false;
        }
      }
      return result;
    },
    cellClick(id, fieldName, record) {

      this.$emit('cellClick',id, fieldName, record);

    },
    showText(record, field){
      if ((field.type == null) || (field.type == '') || (field.type == 'text')) {
        return true;
      } 
      if (field.type == 'input') {
        return !(record.id == this.editId && field.fieldName == this.editName);
      } 
      return false;
    },
    showCheckBox(field) {
      return field.type == 'checkbox';
    },
    showImg(field) {
      return field.type == 'image';
    },
    showTag(field) {
      return field.type == 'tag';
    },
    showOther(field) {
      return field.type == 'other';
    },
    showTemplate(field) {
      return field.type == 'template';
    },
    showSelect(field) {
      return field.type == 'select';
    },
    showInputEdit(record, field) {
      if (field.type == 'input') {
        return !(record.id == this.editId && field.fieldName == this.editName) ;
      }
      return false;
    },
    showInput(record, field) {
      return record.id == this.editId && field.fieldName == this.editName;
    },
    fileNameEdit(event) {

      let id = event.target.getAttribute("data-id");
      let fieldName = event.target.getAttribute("data-field");
      this.$nextTick(() => {
          console.log('text_' + fieldName + '_' + id)
          let value = this.$refs['text_' + fieldName + '_' + id][0].innerHTML;
          this.fileName = value;
      })
      this.editMode = true;
      this.editId = id;
      this.editName = fieldName;
      this.$nextTick(() => {
          let value = 'input_' + fieldName + '_' + id;
          this.$refs[value][0].focus();

      })
      event.stopPropagation();
    },
    fileNameBlur(event) {
      this.data.forEach((i,index) => {           
          if (i.id == this.editId) {
              i[this.editName] = this.fileName;
          }
      })
      console.log(this.data);
      this.editMode = false;
      this.editId = 0;
      this.editName = "";
      console.log(event);
    },
    getOtherStyle(record, field) {
      let result = record[field.fieldName];
      let find = field.styles.filter(item=>item.value == result);
      if (find.length > 0) {
        if(this.formatColor(find[0].value).background != null){
          find[0].style["background"] = this.formatColor(find[0].value).background 
          find[0].style["color"] = this.formatColor(find[0].value).color
          find[0].style["font-weight"] = "bold"
        }
        
        return find[0].style;
      } else {
        return null;
      }
    },
    getStyle(index, field) {
      let result = field.style;
      if (field.fixed && field.fixed == true) {
        if (result == null) {
          result = {}
        }
        result['position'] = 'sticky';
        result['left'] = '0';
        result['right'] = '0';
        result['border-left'] = '1px solid rgba(0, 0, 0, 0.1)';       
        if (index % 2 != 0 ) {
          result['background-color'] = '#F1F4F8';
        } else {
          result['background-color'] = '#fff';
        }
      }
      return result;
    },
    formatColor(text){
      const colorText = (color1,color2)=>{
        return `linear-gradient(145deg, ${color1} 20%, ${color2} 80%)`
      }
      return {
        color:color,
        background:background
      }
    }
  }
}
</script>
<style scoped>
.menu-black {
position: relative;
top: 5px;
border-top-color: #000;
}

.menu-up-black {
position: relative;
bottom: 2px;
border-bottom-color: #000;
}

.resizable {  
  cursor: e-resize;  
}

.table {
  table-layout: fixed;
}

.table th {
position: relative;
}

.table td{
white-space: nowrap;
}

.no-zebra tr {
  background-color: #fff;
}

.tb-border {
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-left: 1px solid rgba(0, 0, 0, 0.2);
}

.td-border {
border-right: 1px solid rgba(0, 0, 0, 0.2);
border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

.fixed {
position: sticky;
left: 0;
right:0;
background-color: #f2f2f2;
border-left: 1px solid rgba(0, 0, 0, 0.1);

}

.breathe {
box-shadow: 0px 0px 8px rgba(211,66,47,0.3) inset;
opacity: 1;
animation: blink 2s ease-in-out 5 alternate;
}

.ldw-text-text{
display: inline-block;
text-align: justify;
line-height: 0;
margin-left: 20rpx;
white-space:normal;
width:60px;
}

.ldw-text-text::after{
content:"";
display: inline-block;
width:100%;
overflow:hidden;
height:0;
}

@keyframes blink {
0% {
  box-shadow: 0px 0px 8px rgba(211,66,47,0.3) inset;
}
25% {
  box-shadow: 0px 0px 8px rgba(211,66,47,0.25) inset;
}
50% {
  box-shadow: 0px 0px 8px rgba(211,66,47,0.2) inset;
}
75% {
  box-shadow: 0px 0px 8px rgba(211,66,47,0.15) inset;
}
100% {
  box-shadow: 0px 0px 8px rgba(211,66,47,0) inset;
}
}



  
</style>


// WEBPACK FOOTER //
// src/components/table/Table.vue